import ConfigRps from './ConfigRps';

export default ConfigRps;
